import myCharacter from '../assets/my-character.jpg';
import sendImailIcon from  '../assets/send_email_icon.svg';


const Header = () => {

    // api 연동 대비해서 json key-value 로 사용
    const contentData = {
        // headerTitle: 'Joonbok Lee',
        // headerTitle: '개발자 ( 이준복 );',
        headerTitle: "It's me, 이준복",
        blogLink: 'https://letsdodev.tistory.com/' || '',
        blogIconHref: myCharacter || '#',
        gitLink: 'https://github.com/ljbok/',
        sendImageIcon: {sendImailIcon}
    }

    return (
        <>
            <header className="border-bottom lh-1 py-3">
                <div className="row flex-nowrap justify-content-between align-items-center">
                    <div className="col-1 pt-1">
                        {/*<a className="link-secondary" href="#"></a>*/}
                    </div>
                    <div className="col-10 text-center">
                        <a className="blog-header-logo text-body-emphasis text-decoration-none" href="#">
                            <div className='custom-header-title fs-1'>{contentData?.headerTitle || ''}</div>
                        </a>
                    </div>
                    <div className="col-1 d-flex justify-content-end align-items-center">
                    </div>
                </div>
            </header>
        </>);
}

export default Header;

